// extracted by mini-css-extract-plugin
export var banner = "_qy-0";
export var settingRow = "_qy-2";
export var titleIcon = "_qy-1";